// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lJ+ce","image":"styles_image__BiR6O","hints":"styles_hints__7CMLu","description":"styles_description__NTtOG"};